import { render } from "./SettingsView.vue?vue&type=template&id=385fbe23&scoped=true&ts=true"
import script from "./SettingsView.vue?vue&type=script&lang=ts"
export * from "./SettingsView.vue?vue&type=script&lang=ts"

import "./SettingsView.scss?vue&type=style&index=0&id=385fbe23&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385fbe23"]])

export default __exports__